import type { CSSProperties, ElementType, FC, ReactElement } from 'react';

import './style.css';

export const defaultBaseColor = '#eee';
export const defaultHighlightColor = '#f5f5f5';

export const skeletonStyles: CSSProperties = {
  backgroundColor: defaultBaseColor,
  backgroundImage: `linear-gradient(90deg, ${defaultBaseColor}, ${defaultHighlightColor}, ${defaultBaseColor} )`,
  backgroundSize: '200px 100%',
  backgroundRepeat: 'no-repeat',
  borderRadius: '4px',
  display: 'inline-block',
  lineHeight: '1',
  width: '100%'
};

interface LoadingSkeletonProps {
  style?: CSSProperties;
  count?: number;
  duration?: number;
  width?: CSSProperties['width'];
  wrapper?: ElementType;
  height?: CSSProperties['height'];
  circle?: boolean;
  className?: string;
}

const LoadingSkeleton: FC<LoadingSkeletonProps> = ({
  count = 1,
  duration = 1.2,
  width,
  wrapper: Wrapper,
  height,
  circle,
  style: customStyle,
  className: customClassName
}) => {
  const elements: ReactElement[] = [];

  for (let i = 0; i < count; i++) {
    const style: CSSProperties = {};

    if (width !== null) {
      style.width = width;
    }

    if (height !== null) {
      style.height = height;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = '50%';
    }

    let className = 'react-loading-skeleton';
    if (customClassName) {
      className += ` ${customClassName}`;
    }

    elements.push(
      <span
        key={i}
        className={className}
        style={{
          animation: `animation-skeleton ${duration}s ease-in-out infinite`,
          ...skeletonStyles,
          ...style,
          ...customStyle
        }}
      >
        &zwnj;
      </span>
    );
  }

  return (
    <>
      {Wrapper
        ? elements?.map((element, i) => (
            <Wrapper key={i}>
              {element}
              &zwnj;
            </Wrapper>
          ))
        : elements}
    </>
  );
};

export default LoadingSkeleton;
